import type { SvgComponent } from '@/types/SvgComponent';

export const WeavyLogoFilled: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M34.6895 0H25.8153V19.4784H21.7818V0H12.9077V19.4784H8.87414V0H0V19.6353H6.45383V30H15.328V19.6353H19.3615V30H28.2356V19.6353H34.6895V0Z"
        fill="currentColor"
      />
    </svg>
  );
};
